import React from "react";
import { Box } from "@material-ui/core";
import Title from "./title";
import Nav from "./nav";
import Grid from "@material-ui/core/Grid";
import { useHeaderStyles } from "./style";

const Header = () => {
  const classes = useHeaderStyles();

  return (
    <Box className={classes.headerBox} sx={{ flexGrow: 1 }}>
      <Grid container>
        <Grid item md={10}>
          <Title />
        </Grid>
        <Grid item md={2}>
          <Nav />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Header;
